import { useState } from 'react';
import { useHistory } from 'react-router';
import { useSelector, useDispatch } from 'react-redux';

import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';

import { selectIsUserAuthenticated } from '../Auth/selector';
import { login } from './action';
import { selectLoginError } from './selector';

const Login = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const isUserAuthenticated = useSelector(selectIsUserAuthenticated);
  const loginError = useSelector(selectLoginError);

  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [isPetOwner, setIsPetOwner] = useState(true);
  const [formEntryError, setFormEntryError] = useState({
    emailError: null,
    passwordError: null,
  });

  const handleOnChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  const validateFormData = () => {
    const error = {
      emailError: null,
      passwordError: null,
    };
    if (!formData.email) {
      error.emailError = 'Email is required';
    }
    if (!formData.password) {
      error.passwordError = 'Password is required';
    }
    setFormEntryError(error);
    return !(error.emailError || error.passwordError);
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const isDataValid = validateFormData();
    if (!isDataValid) return;
    dispatch(login({ ...formData, isPetOwner }));
  };

  if (isUserAuthenticated) {
    history.push('/dashboard');
    return null;
  }

  const PetOwnerSwitch = () => (
    <Switch
      name="isPetOwner"
      color="secondary"
      checked={isPetOwner}
      onChange={e => setIsPetOwner(e.target.checked)}
    />
  );

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        height: 'calc(100vh - 100px)',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Login
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={formData.email}
            onChange={handleOnChange}
            error={formEntryError.emailError !== null}
            helperText={formEntryError.emailError}
          />
          <TextField
            margin="normal"
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={formData.password}
            onChange={handleOnChange}
            error={formEntryError.passwordError !== null}
            helperText={formEntryError.passwordError}
          />
          <FormControlLabel
            control={<PetOwnerSwitch />}
            label={isPetOwner ? 'Pet owner' : 'Pet sitter'}
            sx={{ mt: 1.5 }}
          />
          {loginError && (
            <Alert severity="error" sx={{ mt: 1 }}>{loginError}</Alert>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Login
          </Button>
          <Grid container>
            <Grid item xs>
              <Link href="#" variant="body2">
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link href="/signup" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Container>
  );
};

export default Login;

